import { combineReducers } from "redux";

import { all } from "redux-saga/effects";

import loginReducer from "store/modules/common/loginReducer.js";
import settingReducer from "store/modules/common/settingReducer";
import starshopReducer from "store/modules/common/starshopReducer";
import StarshopSaga from "store/modules/saga/StarshopSaga";
import csboardReducer from "store/modules/common/csboardReducer";
import CSBoardSaga from "store/modules/saga/CSBoardSaga";
import classDetailReducer from "store/modules/common/classDetailReducer";
import initTimeTableReducer from "store/modules/common/initTimeTableReducer";
import commonReducer from "store/modules/common/commonReducer";
import aiReducer from "store/modules/common/aiReducer";
import timeTableReducer from "./common/timeTableReducer";
import spinnerReducer from "./common/spinnerReducer";
import modalReducer from "./common/modalReducer";
import allTabfileReducer from "./common/allTabFileReducer";
import xapiReducer from "./common/xapiReducer";
import toastReducer from "./common/toastReducer";

export const rootModule = combineReducers({
    loginReducer,
    settingReducer,
    starshopReducer,
    csboardReducer,
    classDetailReducer,
    initTimeTableReducer,
    commonReducer,
    aiReducer,
    timeTableReducer,
    spinnerReducer,
    modalReducer,
    allTabfileReducer,
    xapiReducer,
    toastReducer,
});

export function* rootSaga() {
    yield all([StarshopSaga(), CSBoardSaga()]);
}
